import { createContext, ReactNode } from 'react';

export const InteractionContext = createContext<{ mode: 'edit' | 'view' }>({ mode: 'view' });
export const InteractionProvider = ({ mode, children }: { mode: 'edit' | 'view'; children: ReactNode }) => {
  return <InteractionContext.Provider value={{ mode }}>{children}</InteractionContext.Provider>;
};
